var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1113 15.9737V18.9845C21.1125 19.264 21.0551 19.5407 20.9429 19.7968C20.8307 20.0529 20.6661 20.2828 20.4598 20.4717C20.2534 20.6607 20.0098 20.8045 19.7445 20.8941C19.4792 20.9836 19.198 21.0169 18.9191 20.9917C15.8247 20.6562 12.8524 19.6009 10.2408 17.9107C7.81115 16.3698 5.7512 14.3139 4.20728 11.8891C2.5078 9.27087 1.45018 6.28996 1.1201 3.18783C1.09497 2.9103 1.12802 2.63059 1.21714 2.3665C1.30626 2.10242 1.4495 1.85975 1.63775 1.65394C1.82599 1.44814 2.05511 1.2837 2.31051 1.17111C2.56592 1.05852 2.84202 1.00024 3.12123 0.999975H6.13802C6.62604 0.995182 7.09916 1.16766 7.46918 1.48525C7.83921 1.80284 8.0809 2.24389 8.14921 2.72617C8.27654 3.6897 8.51268 4.63575 8.85312 5.54629C8.98842 5.90551 9.0177 6.2959 8.9375 6.67121C8.8573 7.04652 8.67097 7.39103 8.4006 7.66389L7.1235 8.93847C8.55502 11.451 10.6395 13.5314 13.1571 14.9601L14.4342 13.6855C14.7076 13.4157 15.0528 13.2297 15.4288 13.1497C15.8049 13.0696 16.196 13.0989 16.556 13.2339C17.4683 13.5737 18.4163 13.8093 19.3817 13.9364C19.8702 14.0052 20.3163 14.2507 20.6352 14.6264C20.9541 15.002 21.1236 15.4815 21.1113 15.9737Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.42fa4fd6.svg";
export { ForwardRef as ReactComponent };